import axios, { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from 'axios'
import LocalStorage from '../utils/localStorage'

const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://lq-dev-app-apigateway.azurewebsites.net/'

const httpClient: AxiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

httpClient.interceptors.request.use(
    config => {
        const token = LocalStorage.getApiKey()

        if (import.meta.env.DEV) {
            console.log('[HTTP Client] Request:', config.method, config.url, { hasToken: !!token })
        }

        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

httpClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    async error => {
        const originalRequest = error.config as AxiosRequestConfig & { _retry?: boolean }
        const requestUrl = originalRequest?.url || ''
        const isAuthRequest = /\/login(?:$|\?)|\/refresh(?:$|\?)/.test(requestUrl)

        if (error.response?.status === 401 && !isAuthRequest && !originalRequest._retry) {
            originalRequest._retry = true
            try {
                // Refresh via HttpOnly cookie (withCredentials)
                const { data } = await axios.post(
                    `${BASE_URL}user-auth/api/users/refresh`,
                    {},
                    { withCredentials: true }
                )
                LocalStorage.setApiKey(data.accessToken)
                if (originalRequest.headers) {
                    (originalRequest.headers as Record<string, string>).Authorization = `Bearer ${data.accessToken}`
                }
                return httpClient(originalRequest)
            } catch {
                LocalStorage.clearAuth()
            }
        }

        return Promise.reject(error)
    }
)

export default httpClient
